
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/logs",
      function () {
        return require("private-next-pages/logs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/logs"])
      });
    }
  